import React from "react";
import { Container, Typography, Box } from "@mui/material";
import ComingSoon from "../../component/ComingSoon";

const RuleEngine = () => {
  return <ComingSoon pageName="RuleEngine" />;
};

export default RuleEngine;
